import HgButtonLink from '../HgButton/_components/HgButtonLink'
import {type HgButtonGroupProps} from './types'

export default function HgButtonGroup(
  props: Partial<Omit<HgButtonGroupProps, 'contentType'>> & {className?: string}
) {
  if (!props.primaryButtonProps && !props.secondaryButtonProps) return null
  return (
    <div className={props?.className}>
      {props.primaryButtonProps && (
        <HgButtonLink variant="primary" {...props.primaryButtonProps} />
      )}
      {props.secondaryButtonProps && (
        <HgButtonLink
          {...props.secondaryButtonProps}
          variant={props.secondaryButtonProps.variant ?? 'tonal'}
        />
      )}
    </div>
  )
}
